import React, { Component } from 'react';

import styles from './ProAppSteps.module.scss';

const SLIDESHOW_TIMEOUT = 4500;

type Props = {
  proAppSteps: Array<{ description: string; step: string; title: string }>;
  t: (translationId: string) => string;
};

interface State {
  activeSlide: number;
}
class ProAppSteps extends Component<Props, State> {
  autoApplyAppSteps: number | undefined;

  constructor(props: Props) {
    super(props);
    this.state = {
      activeSlide: 0,
    };
    this.autoApplyAppSteps = undefined;
  }

  componentDidMount() {
    if (!this.autoApplyAppSteps) {
      this.autoApplyAppSteps = window.setInterval(() => {
        // eslint-disable-next-line no-magic-numbers
        this.setState((prevState) => ({ activeSlide: (prevState.activeSlide + 1) % 3 }));
      }, SLIDESHOW_TIMEOUT);
    }
  }

  componentWillUnmount() {
    this.stopAppStepAutoPlay();
  }

  slideTo(index: number) {
    this.setState({ activeSlide: index });
    this.stopAppStepAutoPlay();
  }

  stopAppStepAutoPlay() {
    if (this.autoApplyAppSteps) clearInterval(this.autoApplyAppSteps);
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { t, proAppSteps } = this.props;
    const { activeSlide } = this.state;

    return (
      <div className={styles['container']}>
        <h2 className={styles['app-steps-title']}>{t('staticPages:pro.proAppSteps.title')}</h2>
        <p className={styles['app-steps-caption']}>{t('staticPages:pro.proAppSteps.subtitle')}</p>
        <div className={styles['app-steps-container']}>
          <div className={styles['phone-container']}>
            <div className={styles['phone-frame']} />
            <div className={styles['phone-slider-container']}>
              {/* eslint-disable-next-line no-magic-numbers */}
              <div
                className={`phone-screen screen${activeSlide + 1}`}
                title={t('staticPages:pro.proAppSteps.title')}
              />
            </div>
          </div>
          <div className={styles['steps-container']}>
            <div className={styles['steps']}>
              {proAppSteps.map((step, i) => (
                <div
                  key={step.step}
                  className={
                    activeSlide === i
                      ? `${styles['step']} ${styles['step-active']}`
                      : styles['step']
                  }
                  onClick={() => this.slideTo(i)}
                  role="presentation"
                >
                  <div className={styles['step-headline']}>
                    <div className={styles['step-number']}>{step.step}</div>
                    <div className={styles['step-title']}>{step.title}</div>
                  </div>
                  <div
                    className={
                      activeSlide === i
                        ? `${styles['step-description']} ${styles['step-description-active']}`
                        : styles['step-description']
                    }
                  >
                    {step.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <style jsx>
          {`
            .phone-screen {
              background-size: contain;
              height: 320px;
              transition: background-image 0.3s ease;
              width: 146px;
            }

            @media screen and (min-width: 768px) {
              .phone-screen {
                height: 433px;
                width: 200px;
              }
            }
            .screen1 {
              background-image: url('https://res.cloudinary.com/zehitomo/image/upload/w_200/v1597910662/pro-page/phone-request-v2.png');
            }
            .screen2 {
              background-image: url('https://res.cloudinary.com/zehitomo/image/upload/w_200/v1597910666/pro-page/phone-match-v2.png');
            }
            .screen3 {
              background-image: url('https://res.cloudinary.com/zehitomo/image/upload/w_200/v1597910668/pro-page/phone-chat-v2.png');
            }
          `}
        </style>
      </div>
    );
  }
}

export default ProAppSteps;
